import React, { useEffect } from "react";
import { ONGOING_TRANSPORTATIONS } from "../../common/query-keys";
import { useQuery } from "@tanstack/react-query";
import { request } from "../../lib/api";
import { MainTemplates } from "../../components/template/MainTemplates";
import { Transportation } from "../../interface/transportation";
import NotFoundPageContent from "../../components/organisms/NotFoundPageContent";
import { useNavigate } from "react-router";

const MyDrivePage = (props: any) => {
  const navigate = useNavigate();
  const { data: getOngoingData } = useQuery({
    queryKey: ["bottomNavCard"],
    queryFn: async () => {
      const result = await request<Transportation[]>({
        method: "GET",
        url: ONGOING_TRANSPORTATIONS,
      });

      return result;
    },
  });

  useEffect(() => {
    if (getOngoingData && getOngoingData.length > 0) {
      navigate("/task-chargeTransfer", {
        state: {
          data: getOngoingData![0].id,
        },
      });
    }
  }, [getOngoingData]);

  return (
    <>
      {getOngoingData?.length === 0 && (
        <MainTemplates pageTitle="내 운송정보">
          <NotFoundPageContent contentText="현재 진행 중인 운송정보가 없습니다." />
        </MainTemplates>
      )}
    </>
  );
};

export default MyDrivePage;
